import { Math } from '../context'
const nativeMax = Math.max
export default nativeMax
